export default "__VITE_ASSET__BjNYtbgT__"